export const data = [];
for (let i = 0; i < 46; i++) {
  data.push({
    key: i,
    name: `invoice_${i}`,
    vendor: `vender_${i * Math.floor(Math.random() * 200)}`,
    property: `--`,
    amount: `${(
      Math.round(Math.floor(Math.random() * 10000) * 100) / 100
    ).toFixed(2)}`,
    ref: `${Math.floor(Math.random() * 1000)}`,
    uploadedBy: `demoUser${i}@gmail.com`,
    billDate:`${Math.floor(Math.random() * 12)}/${Math.floor(Math.random() * 30)}/2023`,
    dueDate:`${Math.floor(Math.random() * 12)}/${Math.floor(Math.random() * 30)}/2023`,
    postDate:`${Math.floor(Math.random() * 12)}/${Math.floor(Math.random() * 30)}/2023`,
    propertName:`Everything is A-OK LLC - ${Math.floor(Math.random() * 30)} Victory Drive Norman, OK ${Math.floor(Math.random() * 10000)}`,
  });
}

export const purchaseOrderNumbers = [
  "#001",
  "#002",
  "#003",
  "#004",
  "#005",
];
